export const moduleMockExample = `import KanbanService from "../../services/kanban.service";

jest.mock("../../services/kanban.service", () => ({
  getBoardLists: jest.fn(() => []),
  changeListName: jest.fn(() => []),
  addListToBoard: jest.fn(() => []),
  deleteList: jest.fn(() => []),
  changeListPosition: jest.fn(() => [])
}));`;



// WEBPACK FOOTER //
// ./src/slides/02-unit-testing/02-core-concepts/code-examples/06-module-mock-example.js